import {
  CASE_CREATION_ORDERS_CHANGE_FILTER_STATUSES,
  CASE_CREATION_ORDERS_CHANGE_FILTER_DATES,
  CASE_CREATION_ORDERS_RESET_PAGE,
  CASE_CREATION_ORDERS_RECEIVE_ORDERS,
  CASE_CREATION_ORDERS_RECEIVE_ORDER,
  CASE_CREATION_ORDERS_CHANGE_LOADER,
  CASE_CREATION_ORDERS_CHANGE_LOADER_BY_ORDERS,
  CASE_CREATION_ORDERS_CHANGE_SCANNING
} from '../mutations/available'

export default {
  [CASE_CREATION_ORDERS_CHANGE_FILTER_STATUSES] (state, statuses) {
    state.caseCreationOrders.filters.statuses = statuses
  },
  [CASE_CREATION_ORDERS_CHANGE_FILTER_DATES] (state, {createdFrom, createdTo}) {
    state.caseCreationOrders.filters.createdFrom = createdFrom
    state.caseCreationOrders.filters.createdTo = createdTo
  },
  [CASE_CREATION_ORDERS_RESET_PAGE] (state) {
    state.caseCreationOrders.pagination.page = 1
  },
  [CASE_CREATION_ORDERS_RECEIVE_ORDERS] (state, {items, total}) {
    state.caseCreationOrders.items = items
    state.caseCreationOrders.totalItems = total
  },
  [CASE_CREATION_ORDERS_RECEIVE_ORDER] (state, order) {
    state.caseCreationOrders.items.push(order)
  },
  [CASE_CREATION_ORDERS_CHANGE_LOADER] (state, loading) {
    state.caseCreationOrders.loading = loading
  },
  [CASE_CREATION_ORDERS_CHANGE_LOADER_BY_ORDERS] (state, {orderId, action, value}) {
    state.caseCreationOrders.progressByOrders = {
      ...state.caseCreationOrders.progressByOrders,
      [orderId]: {
        progress: value,
        [action]: value
      }
    }
  },
  [CASE_CREATION_ORDERS_CHANGE_SCANNING] (state, value) {
    state.caseCreationOrders.scanning = value
  }

}
